var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { html } from "lit";
import { property } from "lit/decorators.js";
import { OmniElement } from "../../omni-element.js";
import { omniStyleSheets } from "../../omni-stylesheets.js";
import allStylesScoped from "../../styles/all-scoped.js";
class OmniStyle extends OmniElement {
  _styleListener(event) {
    const { detail = {} } = event;
    if (detail instanceof Function) {
      detail.call(this, event, this);
    } else {
      Object.entries(detail).forEach(this.setProperty, this);
    }
  }
  setProperty([name = "", value = ""]) {
    this.style.setProperty(name, value);
  }
  constructor() {
    super();
    this._styleListener = this._styleListener.bind(this);
    this.accessible = window?.omniUIStyles?.accessible === true || false;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    self.removeEventListener("omni-style", this._styleListener);
  }
  connectedCallback() {
    super.connectedCallback();
    self.addEventListener("omni-style", this._styleListener);
    const root = this.getRootNode();
    if (root instanceof HTMLDocument && this.children.length === 0) {
      root.firstElementChild.classList.add("omni");
    } else if (!this.closest(".omni")) this.classList.add("omni");
    if (!root.adoptedStyleSheets.includes(omniStyleSheets[0])) {
      let stylesToAdopt = [
        ...omniStyleSheets,
        // inject shared omni sheets first, so component sheets can override
        ...root.adoptedStyleSheets
      ];
      if (this.accessible) {
        const allStylesSheet = new CSSStyleSheet();
        allStylesSheet.replaceSync(allStylesScoped.cssText);
        stylesToAdopt = [...omniStyleSheets, allStylesSheet, ...root.adoptedStyleSheets];
      }
      root.adoptedStyleSheets = stylesToAdopt;
    }
  }
  render() {
    return html`<slot></slot>`;
  }
}
__decorateClass([
  property({ type: Boolean })
], OmniStyle.prototype, "accessible", 2);
OmniElement.register("omni-style", OmniStyle);
export {
  OmniStyle
};
//# sourceMappingURL=omni-style.js.map
